import { useAtomValue, useSetAtom } from 'jotai';

import { useDeepEffect } from '@crossnokaye/ux-common';

import { scrollContainerAtom, scrollPositionAtom } from '@/components/app-layout/app-layout.state';

export const useScrollPositionTracking = () => {
  const scrollContainer = useAtomValue(scrollContainerAtom);
  const setScrollPosition = useSetAtom(scrollPositionAtom);

  useDeepEffect(() => {
    if (!scrollContainer) return;

    const handleScroll = () => {
      setScrollPosition(scrollContainer.scrollTop);
    };

    handleScroll();

    scrollContainer.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [scrollContainer]);
};
